export default "__VITE_PUBLIC_ASSET__fb57839d__"